module.exports = __webpack_public_path__ + "assets/img/hcbbg1.3730a8b2.png";